<template>
  <div class="admin-stats-view">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>动态链接访问统计</span>
        <el-button style="float: right; padding: 3px 0" type="primary" :loading="loading" @click="loadStats">刷新数据</el-button>
      </div>

      <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="8">
          <el-card class="stat-card">
            <div class="stat-content">
              <div class="stat-title">链接总数</div>
              <div class="stat-number">{{ stats.totalCount || 0 }}</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="stat-card">
            <div class="stat-content">
              <div class="stat-title">启用链接</div>
              <div class="stat-number">{{ stats.activeCount || 0 }}</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="stat-card">
            <div class="stat-content">
              <div class="stat-title">停用链接</div>
              <div class="stat-number">{{ stats.inactiveCount || 0 }}</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="24">
          <el-card class="stat-card">
            <div class="stat-content">
              <div class="stat-title">累计访问次数</div>
              <div class="stat-number">{{ stats.totalVisits || 0 }}</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="12">
          <el-card class="stat-card">
            <div class="stat-content">
              <div class="stat-title">默认规则命中</div>
              <div class="stat-number">{{ (stats.ruleHits && stats.ruleHits.defaultHits) || 0 }}</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="stat-card">
            <div class="stat-content">
              <div class="stat-title">条件规则命中</div>
              <div class="stat-number">{{ (stats.ruleHits && stats.ruleHits.conditionalHits) || 0 }}</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-divider>Top 10 链接</el-divider>
      <el-table :data="topLinks" stripe :loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="shortCode" label="短码" align="center"></el-table-column>
        <el-table-column prop="visitCount" label="访问次数" align="center"></el-table-column>
      </el-table>

      <el-divider>URL命中统计</el-divider>
      <el-table :data="ruleHitsByUrl" stripe :loading="loading" style="width: 100%">
        <el-table-column prop="url" label="URL" align="center"></el-table-column>
        <el-table-column prop="hitCount" label="命中次数" align="center"></el-table-column>
      </el-table>

      <el-divider>规则详细统计</el-divider>
      <el-table :data="ruleDetails" stripe :loading="loading" style="width: 100%">
        <el-table-column prop="linkName" label="链接名称" align="center"></el-table-column>
        <el-table-column prop="ruleType" label="规则类型" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.ruleType === 'default' ? 'primary' : 'success'">{{ scope.row.ruleType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ruleUrl" label="跳转URL" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ruleRegion" label="地区条件" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.ruleRegion && scope.row.ruleRegion.length > 0">{{ Array.isArray(scope.row.ruleRegion) ? scope.row.ruleRegion.join(', ') : scope.row.ruleRegion }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="rulePriority" label="优先级" align="center"></el-table-column>
        <el-table-column prop="hitCount" label="命中次数" align="center"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      stats: {},
      topLinks: [],
      ruleHitsByUrl: [],
      ruleDetails: []
    };
  },
  created() {
    this.loadStats();
  },
  methods: {
    loadStats() {
      this.loading = true;
      this.$http.get('admin/links/stats').then((res) => {
        const data = res.data.data || {};
        this.stats = data;
        this.topLinks = data.topLinks || [];
        this.ruleHitsByUrl = (data.ruleHits && data.ruleHits.ruleHitsByUrl) || [];
        this.ruleDetails = (data.ruleHits && data.ruleHits.ruleDetails) || [];
      }).catch(() => {
        this.$Message.warning('统计信息加载失败');
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.stat-card {
  text-align: center;
}

.stat-content {
  padding: 20px 0;
}

.stat-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/Stats.vue